import styled from '@emotion/styled';
import { TextField, FormControl } from '@mui/material';
import Grid from '@mui/material/Grid';

/*
  Shared optional fields collected when creating an account (BT-9485):
    - HubSpot Record ID (numeric company id)
    - Internal Email Domain(s) (comma-separated; used to tell internal users from external)

  Both are uncontrolled inputs read by serializeFormData on submit (names
  `hubspot_record_id` and `email_domains`). Reused by the unbilled screen and the
  billed "details" step. The billed step prefills `defaultHubspotRecordId` from the
  Recurly billing code (only when it is numeric).
*/

const GridContainer = styled(Grid)`
  margin-bottom: 16px;
`;

const FieldLabel = styled(Grid)`
  font-weight: bold;
  font-size: 14px;
`;

function OptionalAccountFields({ defaultHubspotRecordId = '', defaultEmailDomains = '' }) {
  return (
    <>
      <GridContainer item xs={12} md={6}>
        <FormControl fullWidth>
          <Grid container alignItems="center" spacing={2}>
            <FieldLabel item xs={12} sm={3}>HubSpot Record ID:</FieldLabel>
            <Grid item xs={12} sm={6}>
              <TextField
                name="hubspot_record_id"
                fullWidth
                size="small"
                type="text"
                defaultValue={defaultHubspotRecordId}
                helperText="Optional. The account's numeric HubSpot company record id."
                inputProps={{ placeholder: 'e.g. 327604874943' }}
              />
            </Grid>
          </Grid>
        </FormControl>
      </GridContainer>
      <GridContainer item xs={12} md={6}>
        <FormControl fullWidth>
          <Grid container alignItems="center" spacing={2}>
            <FieldLabel item xs={12} sm={3}>Internal Email Domains:</FieldLabel>
            <Grid item xs={12} sm={6}>
              <TextField
                name="email_domains"
                fullWidth
                size="small"
                type="text"
                defaultValue={defaultEmailDomains}
                helperText="Optional. Comma-separated (e.g. acme.com, acme.aero). Used to tell internal users from external."
                inputProps={{ placeholder: 'acme.com, acme.aero' }}
              />
            </Grid>
          </Grid>
        </FormControl>
      </GridContainer>
    </>
  );
}

export default OptionalAccountFields;
